const axios = require("axios")
const _ = require('lodash')

exports.render = function (comp, values, format, author) {
  if (comp.type === 'gChart') return generateGChartImg(comp, values, format)
  return getChartPoints(comp.apiPath, author || comp.author, values, comp.pointLabel, comp.suffix, comp.serieLabels)
      .then(dataTable => {
        const options = {
          "title": `${comp.label} (${author || comp.author}), ${comp.article}`,
          "subtitle": "",
          "axisTitlesPosition": "out",
          "curveType": "function",
          "colors": ["#e98e7a", "#b5bcc7", "#e98e7a", "#15A0C8", "#981b48", "#6fa348", "#ec8a33", "#909895"],
          "series": {
            "0": {"visibleInLegend": false},
            "1": {"visibleInLegend": false},
            "2": {"visibleInLegend": false},
            "3": {"pointShape": "circle", "pointSize": 12, "lineWidth": 0},
            "4": {"pointShape": "square", "pointSize": 12, "lineWidth": 0},
            "5": {"pointShape": "diamond", "pointSize": 12, "lineWidth": 0},
            "6": {"pointShape": "polygon", "pointSize": 12, "lineWidth": 0}
          },
          "backgroundColor": {"stroke": "#000000", "strokeWidth": 1},
          "chartArea": {"width": "75%", "height": "70%"},
          "legend": {"position": "bottom"},
          "hAxis": {"title": comp.xLabel || "Semanas"},
          "vAxis": {"title": comp.suffix || "mm", "viewWindowMode": "maximized"},
        }

        // ajuste das series e cores
        if (comp.serieLabels) {
          const series = {}
          const seriesLength = comp.serieLabels.length
          for (let i = 0; i < seriesLength - 1; i++) {
            series[i] = { visibleInLegend: false }
          }
          series[seriesLength - 1] = { pointShape: 'circle', pointSize: 12, lineWidth: 0 }
          series[seriesLength] = { pointShape: 'square', pointSize: 12, lineWidth: 0 }
          series[seriesLength + 1] = { pointShape: 'diamond', pointSize: 12, lineWidth: 0 }
          series[seriesLength + 2] = { pointShape: 'polygon', pointSize: 12, lineWidth: 0 }
          options.series = series
        }
        if (comp.serieColors) {
          options.colors = comp.serieColors.concat(['#15A0C8', '#981b48', '#6fa348', '#ec8a33', '#909895'])
        }

        let chart = {
          "chartType": "LineChart",
          dataTable,
          options
        }
        return axios.post('https://charts-cloudrun-vvlogug2ya-ue.a.run.app', {chart, format})
      })
}

function generateGChartImg(comp, values, format) {
  let axiosUrl = ""
  let axiosData = {}
  let chart = {}
  let dataTable = []

  let options = {
    title: comp.title,
    "sliceVisibilityThreshold": "0",
    "backgroundColor": {"stroke": "#000000", "strokeWidth": 1},
    "legend": comp.legend === false ? { "position": "none" } : true
  }

  if (comp.colors !== null && comp.typeChart === 'ColumnChart') {
    for (let row = 0; row < (Object.keys(values).length - 1); row++) {
      let columnArray = []
      if (values[row].length !== 0) {
        columnArray[0] = values[row][0]
        columnArray[1] = (row === 0) ? values[row][1] : parseFloat(values[row][1])
        columnArray[2] = (row === 0) ? { role: 'style' } : comp.colors[row-1]
        dataTable[row] = columnArray
      }
    }
  } else {
    for (let row = 0; row < (Object.keys(values).length - 1); row++) {
      let columnArray = []
      if (values[row].length !== 0) {
        columnArray[0] = values[row][0]
        columnArray[1] = (row === 0) ? values[row][1] : parseFloat(values[row][1])
        dataTable[row] = columnArray
      }
    }
    if (comp.colors !== null) options.colors = comp.colors
  }

  // let dataTable = values
  chart = {
    "chartType": comp.typeChart, // typeChart
    dataTable,
    options
  }
  axiosUrl = 'https://charts-cloudrun-vvlogug2ya-ue.a.run.app'
  axiosData = {chart, format}

  // TABELA
  // if (comp.typeChart === 'Table') {
  //   let columns = []
  //   let dataSource = []

  //   for (let i = 0; i < Object.keys(values[0]).length; i++) {
  //     let dataIndex = i === 0 ? "title" : values[0][i]
  //     if(dataIndex === "Risco específico do paciente") dataIndex = "Risco especifico do paciente"
  //     columns[i] = {
  //       "width": 250,
  //       "title": values[0][i],
  //       "dataIndex": dataIndex
  //     }
  //     // console.log(JSON.stringify(columns[i]))
  //   }
  //   for (let i = 0; i < Object.keys(values).length-2; i++) {
  //     let index = i+1
  //     dataSource[i] = {
  //       "title": values[index][0],
  //       "Risco especifico do paciente": values[index][1],
  //       "Risco relativo": values[index][2],
  //       "Risco de linha de base": values[index][3]
  //     }
  //     // console.log(JSON.stringify(dataSource[i]))
  //   }

  //   let data = {columns, dataSource}
  //   let options = {
  //     "paddingVertical": 20,
  //     "paddingHorizontal": 20,
  //     "backgroundColor": "#eee",
  //     "fontFamily": "aria-label"
  //   }

  //   axiosUrl = 'https://api.quickchart.io/v1/table'
  //   axiosData = {data, options}
  // }
  return axios.post(axiosUrl, axiosData)
}

function getChartPoints (apiPath, author, values, label, unit = 'mm', serieLabels =  ['X', '5%', '50%', '95%']) {
  return new Promise((resolve, reject) => {
    let url = 'https://api.ultrahealth.care' + apiPath
    if (author) url += '?author=' + author
    axios.get(url)
        .then(res => {
          let chartData = [
            _.clone(serieLabels)
          ]

          // Ajusta a unidade de medida
          let mult = 1
          if (unit === 'cm') {
            mult = 0.1
          }
          // Verifica se as series tem os nomes personalizados
          if (serieLabels[0] === 'X') {
            res.data.forEach(p => {
              chartData.push([p['measure'], p['p5'] * mult, p['p50'] * mult, p['p95'] * mult])
            })
          } else {
            res.data.forEach(p => {
              let linePoints = []
              for (let i = 0; i < serieLabels.length; i++) {
                linePoints.push(p[i] * (i === 0 ? 1 : mult))
              }
              chartData.push(linePoints)
            })
          }

          // hash items
          let hsh = values.reduce((acc, item) => {
            if (!acc[item.id]) acc[item.id] = []
            acc[item.id].push(item)
            return acc
          }, {})

          // limits
          let min = chartData[1][0]
          let max = chartData[chartData.length-1][0]
          let minItem = max
          let maxItem = min

          // fix table
          for (let i = 1; i < chartData.length; i++) {
            chartData[i] = chartData[i].concat(new Array(Object.keys(hsh).length).fill(null))
          }

          const cols = chartData[1].length;
          for (let k in hsh) {
            // add header item
            chartData[0].push(`${label} ${k}`)

            // item column
            let itemCol = chartData[0].length - 1;
            let items = hsh[k]
            // percorre os pontos
            for (let p in items) {
              let item = items[p]
              // add line empty
              let point = new Array(cols).fill(null)
              point[0] = item.week
              if (item.week < minItem) minItem = item.week
              if (item.week > maxItem) maxItem = item.week
              point[itemCol] = item.value * mult
              chartData.push(point)
            }
          }

          // define limits
          if (minItem > max) minItem = max
          if (maxItem < min) maxItem = min
          const offset = 3;
          minItem -= offset
          maxItem += offset
          chartData = chartData.filter(item => typeof item[0] === 'string' || (item[0] >= minItem && item[0] <= maxItem))
          return resolve(chartData)
        })
        .catch(err => {
          console.error(err)
        })
  })
}



// WEBPACK FOOTER //
// ./functions/print/printChart.js